import { useEffect, useState } from "react";
import { GetUserListReqQuery } from "../types/userContract";
import { User } from "../types/user";
import apiGetUserList from "../api/user/apiGetUserList";
import { useAppContext } from "../contexts/DataContext";
import { useDisplayContext } from "../contexts/DisplayContext";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";

const useUserList = (query?: GetUserListReqQuery) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const { notify } = useDisplayContext();
  const { dispatch } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<User[]>([]);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async (newQuery?: GetUserListReqQuery) => {
    if (newQuery) query = newQuery;

    let resData: User[] | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetUserList(query);

      setData(res.json.data);

      dispatch({
        type: "GET",
        payload: {
          type: "drivers",
          data: res.json.data,
        },
      });

      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
      notify.error("Gagal mendapatkan data driver")
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
  };
};

export default useUserList;
